import donnees from "./services-pages.json";

/**
 * Une page par service, nommee par le LIVRABLE et jamais par le metier.
 *
 * Motif mesure au SERP : « developpeur web Quebec » sort une page de resultats
 * d'emploi a 8 sur 9, « application web sur mesure Quebec » sort une page
 * commerciale a 9 sur 9. La page vise la seconde intention.
 */
export type PageService = {
  slug: string;
  nom: string;
  /** Cible de mots calculee sur la mediane du SERP, plancher 1200. */
  cibleMots: number;
  misAJour: string;
  probleme: string;
  cequeCeNestPas: string[];
  livrables: string[];
  stack: string[];
  processus: { etape: string; description: string }[];
  projetsMisEnAvant: string[];
  faq: { question: string; reponse: string }[];
  motsCles: { principal: string; secondaires: string[] };
  meta: { title: string; description: string };
  redaction: { accroche: string; reponseExtractible: string; corps: string };
  servicesLies: string[];
};

export const servicesPages: PageService[] = donnees as PageService[];

export function trouverService(slug: string): PageService | undefined {
  return servicesPages.find((s) => s.slug === slug);
}
